import type { OrderType } from '../types/order'

export const orderInitialValues: OrderType = {
  shipMethod: null,
  orderResponse: { empty: true },
  copyShipping2Billing: false,
  lastPaymentMethod: null,
  tax: null,
  shipping: {
    fullName: '',
    email: '',
    phone: '',
    address1: '',
    address2: '',
    state: '',
    city: '',
    zip: '',
    country: '',
  },
  paypal: {
    isFailed: false,
    account: {
      nonce: '',
    },
    firstName: '',
    lastName: '',
  },
  worldPay: {
    isDdcIframeOpen: false,
    isChallengeIframeOpen: false,
    challengeHTML: null,
    worldPaySessionId: null,
  },
  cashLocations: [],
  total: null,
  lastFreeItems: [],
  discount: null,
  selectedVolumePeriod: null,
  recurrence: {
    selected: 'now_then_every_30_days',
    schedule: {
      month: '*',
      dayOfMonth: new Date().getDate().toString(),
      skipRepetitions: '1',
    },
  },
  shouldShipNow: true,
}
